/* PWW v60: default product listing pages to lowest price first. */
(function () {
  var defaultSort = 'price-ascending';
  var path = window.location.pathname;
  var isCollectionPage = /^\/collections(?:\/|$)/.test(path);
  var isSearchPage = /^\/search\/?$/.test(path);

  if (!isCollectionPage && !isSearchPage) return;

  var params = new URLSearchParams(window.location.search);
  if (params.has('sort_by')) return;

  if (isSearchPage && !params.get('q')) return;

  params.set('sort_by', defaultSort);
  window.location.replace(path + '?' + params.toString() + window.location.hash);
})();
